/**
 * Return a filtered list based on a filter query
 *
 * @param  {Object} state
 * @return {Array}
 */
const filteredProjects = (state) => {
    let term = state.searchTerm ? state.searchTerm.toLowerCase() : ''
    if (state.data) {
        return state.data.filter(project => {
            let name = project.project_name.toLowerCase()
            return name.includes(term)
        })
    }
    return []
}

export default {
    filteredProjects
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/links/getters.js